import FullBlock from "../Block/FullBlock";
import {
  fullTimeJobs,
  personalProjects,
  internships,
  competitions,
  outsideProjects,
  softwareProjects,
  blockchainProjects,
  dataProjects,
} from "../../data/coding";

export default function BlockCodingHeader() {
  return (
    <div>
      {TitleLists.map((detail, index) => {
        const { header, detailsName } = detail;
        return <FullBlock key={index} header={header} detailsName={detailsName} />;
      })}
    </div>
  );
}

const TitleLists = [
  { header: "Full Time Work", detailsName: fullTimeJobs },
  { header: "Personal Projects", detailsName: personalProjects },
  { header: "Internships", detailsName: internships },
  { header: "Competitions", detailsName: competitions },
  { header: "Outside of School", detailsName: outsideProjects },
  { header: "Software Projects", detailsName: softwareProjects },
  { header: "Blockchain Projects", detailsName: blockchainProjects },
  { header: "Data & Artificial Intelligence Projects", detailsName: dataProjects },
];
